<template>
  <section id="home" class="content">
    <div class="processingCnt">
      <div v-if="detail && detail.video" class="videoOnly">
        <div v-bind:class="{videoCnt: true, loading: true}"
          v-if="!detail || detail.status === 'processing'">
        </div>
        <div v-bind:class="{videoCnt: true, loading: false}" v-else
          v-bind:style="{backgroundImage: `url(${mainThumbSrc})`}">
        </div>
        <div class="progressCnt" v-if="!detail || loading">
          <div class="progress processing" style="width: 0">
            <span>Processing 0%</span>
            <div class="bg"></div>
          </div>
        </div>
        <div class="progressCnt" v-else>
          <div class="progress processing" v-bind:style="{width: `${detail.video.progress}%`}"
            v-if="detail.video.status === 'processing'">
            <span>Processing {{detail.video.progress}}%</span>
            <div class="bg"></div>
          </div>
          <div class="progress" v-bind:style="{width: '100%'}"
            v-else>
            <span>Finished Proccessing</span>
          </div>
        </div>
      </div>
      <h4 class="h41">Content Information</h4>
      <p class="subtitle">You can fill video information while waiting video
        processing to finish.</p>
      <div class="fieldCnt">
        <label>Title</label>
        <input type="text" placeholder="Title" v-model="form.title">
        <div class="fieldHint">Give title for this content.</div>
      </div>
      <div class="fieldCnt">
        <label>Description</label>
        <textarea rows="4" placeholder="Description..." v-model="form.desc"></textarea>
        <div class="fieldHint">Descrption about this content.</div>
      </div>
      <h4>Audio File</h4>
      <p class="subtitle">Audio file for podcast, user doesn't have to load
        video for listening to podcast.</p>
      <div class="addAudio" v-on:click="addAudio">
        <div class="aa">
          <img src="../assets/musical-note-white.svg" class="white">
          <img src="../assets/musical-note-blue.svg" class="blue">
          <span v-if="!audioFile">Add Audio File</span>
          <span v-else>{{audioFile.name}}</span>
        </div>
      </div>
      <h4>Thumbnail</h4>
      <div class="thumbCnt" v-if="detail && detail.video">
        <div v-bind:class="{thumbItem: true, addImage: true, active: mainThumb === 0}"
          v-on:click="addImage">
          <div class="ai" v-if="!customThumb">
            <img src="../assets/upload.png">
            Upload Image
          </div>
          <div class="chImg" v-on:click="changeImg" v-if="customThumb">Change Image</div>
          <div class="theImg" v-bind:style="{backgroundImage: `url(${customThumb.imageSm})`}"
            v-if="customThumb"></div>
        </div>
        <div v-bind:class="{thumbItem: true, loading: !detail || !detail.video.thumb1,
          active: mainThumb === 1}" v-on:click="mainThumb = 1">
          <div class="theImg" v-bind:style="{backgroundImage: `url(${detail.video.thumb1})`}"
            v-if="detail && detail.video.thumb1"></div>
        </div>
        <div v-bind:class="{thumbItem: true, loading: !detail || !detail.video.thumb2,
          active: mainThumb === 2}" v-on:click="mainThumb = 2">
          <div class="theImg" v-bind:style="{backgroundImage: `url(${detail.video.thumb2})`}"
            v-if="detail && detail.video.thumb2"></div>
        </div>
        <div v-bind:class="{thumbItem: true, loading: !detail || !detail.video.thumb3,
          active: mainThumb === 3}" v-on:click="mainThumb = 3">
          <div class="theImg" v-bind:style="{backgroundImage: `url(${detail.video.thumb3})`}"
            v-if="detail && detail.video.thumb3"></div>
        </div>
      </div>
      <div class="thumbCnt" v-else>
        <div v-bind:class="{thumbItem: true, addImage: true, active: mainThumb === 0}"
          v-on:click="addImage">
          <div class="ai" v-if="!customThumb">
            <img src="../assets/upload.png">
            Upload Image
          </div>
          <div class="chImg" v-on:click="changeImg" v-if="customThumb">Change Image</div>
          <div class="theImg" v-bind:style="{backgroundImage: `url(${customThumb.imageSm})`}"
            v-if="customThumb"></div>
        </div>
      </div>
    </div>

    <div class="formAction">
      <div class="formActionCnt">
        <button v-bind:class="{btn: true, btnPrimary: true,
          disabled: loading, loading: saving}" v-on:click="saveNow">
          <span>Publish</span>
        </button>
        <div class="btnConfig">
          <div class="theBtn" v-on:click="configOpen = true"></div>
          <div class="configOverlay" v-if="configOpen"
            v-on:click="configOpen = false"></div>
          <div class="configContent" v-if="configOpen">
            <div class="configItem">
              <h4>Content Info</h4>
              <!--
              <div class="ciItem">
                Status
                <span>Draft</span>
              </div>
              <div class="ciItem">
                Visibility
                <span>Hidden</span>
              </div>
              -->
              <div class="ciItem">
                Author
                <span>{{$session.get('name')}}</span>
              </div>
            </div>
            <div class="configItem">
              <h4>Keywords</h4>
              <p>Add keywords in field below, separate by comma.</p>
              <textarea rows="3" class="field" v-model="form.keyword"
                placeholder="Keywords..."></textarea>
            </div>
            <div class="configItem">
              <h4>Start at</h4>
              <p>Video/audio will start after user click play in seconds.</p>
              <input type="number" class="field" v-model="form.startAt"
                placeholder="Start at" />
            </div>
          </div>
        </div>
        <div :class="{draftSaved: true, loading: (draftStatus == 'loading')}"
          v-if="draftStatus">
          <span>Saved</span>
          <div class="loadingImg">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
              <g transform="translate(20 50)">
                <circle cx="0" cy="0" r="6" fill="#b2d1ff" transform="scale(0.97694 0.97694)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.375s"
                    calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                    keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                </circle>
              </g><g transform="translate(40 50)">
                <circle cx="0" cy="0" r="6" fill="#72a7f5" transform="scale(0.918245 0.918245)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.25s"
                    calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                    keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                </circle>
              </g><g transform="translate(60 50)">
                <circle cx="0" cy="0" r="6" fill="#2e77e4" transform="scale(0.618706 0.618706)">
                  <animateTransform attributeName="transform" type="scale" begin="-0.125s"
                    calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                    keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                </circle>
              </g><g transform="translate(80 50)">
                <circle cx="0" cy="0" r="6" fill="#0057d8" transform="scale(0.269344 0.269344)">
                  <animateTransform attributeName="transform" type="scale" begin="0s"
                    calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                    keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                </circle>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <MediaSelector v-if="showMediaSelector" v-on:close="showMediaSelector = false"
      v-on:ok="imageOk"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'home',
  components: { MediaSelector },
  data() {
    return {
      parent: null,
      loading: true,
      detail: null,
      model: null,
      showMediaSelector: false,
      mediaSelectorFor: null,
      mainThumb: 1,
      customThumb: null,
      audioFile: null,
      draftStatus: null,
      saving: false,
      podcastId: null,
      configOpen: false,
      form: {
        title: '',
        desc: '',
        keyword: '',
        startAt: '',
      },
      reload: false,
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    getData() {
      const { id } = this.$route.params;
      this.podcastId = id;
      this.$http.get(this.$config.uri(`podcast/detail/${id}`)).then((response) => {
        this.detail = (response.data.status === 200) ? response.data.data : null;
        this.loading = false;
        if (this.detail) {
          if (!this.reload) {
            this.form.title = this.detail.title;
          }
          if (!this.reload) {
            this.form.desc = this.detail.description;
          }
          if (!this.reload) {
            this.form.keyword = this.detail.keyword;
          }
          if (this.detail.selectedThumb === null) {
            this.mainThumb = 1;
          } else {
            this.mainThumb = this.detail.selectedThumb;
          }
          if (this.detail.startAt) {
            this.startAt = this.detail.startAt;
          }
          if (this.detail.customThumb) {
            this.customThumb = this.detail.customThumb;
          }
          if (this.detail.audio) {
            this.audioFile = this.detail.audio;
          }
          this.reload = false;
          if (this.detail.video && this.detail.video.status !== 'processed') {
            this.reload = true;
            setTimeout(this.getData, 4000);
          }
        }
      });
    },
    imageOk(media) {
      if (this.mediaSelectorFor === 'audio') {
        this.showMediaSelector = false;
        if (media.type !== 'audio') return;
        this.audioFile = media;
      } else {
        this.showMediaSelector = false;
        if (media.type !== 'image') return;
        this.customThumb = media;
        this.mainThumb = 0;
      }
    },
    addImage() {
      this.mediaSelectorFor = 'thumb';
      if (!this.customThumb) this.showMediaSelector = true;
      else this.mainThumb = 0;
    },
    changeImg() {
      this.mediaSelectorFor = 'thumb';
      this.showMediaSelector = true;
    },
    addAudio() {
      this.mediaSelectorFor = 'audio';
      this.showMediaSelector = true;
    },
    saveNow() {
      if (this.loading || this.saving) return;
      this.saving = true;
      const cstTh = (this.customThumb) ? this.customThumb.id : null;
      const audioId = (this.audioFile) ? this.audioFile.id : null;
      const videoId = (this.detail && this.detail.video) ? this.detail.video.id : null;
      this.$http.post(this.$config.uri('podcast/save'), {
        id: this.podcastId,
        video: videoId,
        audio: audioId,
        thumb: this.mainThumb,
        customThumb: cstTh,
        title: this.form.title,
        desc: this.form.desc,
        keyword: this.form.keyword,
        status: 'published',
        parent: this.parent.slug,
        startAt: this.form.startAt,
      }).then((response) => {
        this.saving = false;
        if (response.data.status !== 200) return;
        this.$router.push(`/video/${this.parent.slug}`);
      });
    },
  },
  computed: {
    mainThumbSrc() {
      if (!this.detail) return null;
      if (!this.detail.video) return null;
      if (this.mainThumb === 0) return (this.customThumb) ? this.customThumb.imageLg : null;
      return this.detail.video[`thumb${this.mainThumb}`];
    },
  },
  mounted() {
    this.chCGB(true);
    this.getData();
    const { parent } = this.$route.query;
    this.$http.get(this.$config.uri(`podcast/parent/${parent}`)).then((response) => {
      this.parent = response.data.data;
      this.chTitle(this.parent.name);
    });
  },
};
</script>

<style scoped lang="scss">
.processingCnt{
  padding: 30px 0 100px;
  max-width: 700px;
  margin: 0 auto;
  .videoCnt{
    width: 100%;
    height: 300px;
    background-color: #ccc;
    border-radius: 5px 5px 0 0;
    background-position: center;
    background-size: cover;
    &.loading{
      background-image: url(../assets/loading-2.svg);
      background-size: 70px auto;
      background-repeat: no-repeat;
    }
  }
  .progressCnt{
    background-color: #ccc;
    height: 40px;
    border-radius: 0 0 5px 5px;
    overflow: hidden;
    .progress{
      height: 100%;
      background-color: #0bad00;
      color: #fff;
      white-space: nowrap;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      padding: 6px 20px;
      box-sizing: border-box;
      position: relative;
      transition: all .6s ease;
      span{
        position: relative;
        z-index: 2;
      }
      @-webkit-keyframes MOVE-BG {
        from {
          -webkit-transform: translateX(0);
        }
        to {
          -webkit-transform: translateX(46px);
        }
      }
      @keyframes MOVE-BG {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(46px);
        }
      }
      .bg{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        overflow: hidden;
        z-index: 1;
      }
      &.processing{
        background-color: orange;
      }
      &.processing .bg:before{
        display: block;
        content: "";
        position: absolute;
        left: -46px;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background: -webkit-repeating-linear-gradient(
          145deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        background: repeating-linear-gradient(
          -55deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        -webkit-animation-name: MOVE-BG;
        -webkit-animation-duration: .6s;
        -webkit-animation-timing-function: linear;
        -webkit-animation-iteration-count: infinite;
        animation-name: MOVE-BG;
        animation-duration: .6s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }
    }
  }
  .videoOnly{
    margin-bottom: 30px;
  }
  h4{
    font-size: 30px;
    margin: 30px 0 20px;
    &.h41{
      margin-top: 0;
    }
  }
  p.subtitle{
    margin: -16px 0 20px;
  }
  input, textarea{
    outline: 0;
    border: #ccc 1px solid;
    padding: 12px;
    border-radius: 5px;
    display: block;
    width: 100%;
    box-sizing: border-box;
    font-size: 18px;
    &:hover{
      border-color: #222;
    }
    &:focus{
      border-color: #0747a6;
    }
  }
  .thumbCnt{
    display: flex;
    margin: 0 -5px;
    .thumbItem{
      width: calc(25% - 10px);
      margin: 0 5px;
      height: 100px;
      background-color: #ccc;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      .chImg{
        position: absolute;
        z-index: 4;
        color: #444;
        background: #fff;
        padding: 2px 8px 4px;
        border-radius: 23px;
        font-size: 14px;
        right: 10px;
        top: 10px;
        &:hover{
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        }
      }
      &:before{
        content: "";
        display: block;
        position: absolute;
        background-color: #999;
        left: -3px; right: -3px; top: -3px; bottom: -3px;
        opacity: 0;
        transition: all .2s ease;
        border-radius: 7px;
        z-index: 1;
      }
      &:after{
        content: "";
        display: block;
        position: absolute;
        background-color: #ccc;
        left: 0px; right: 0px; top: 0px; bottom: 0px;
        border-radius: 5px;
        z-index: 2;
      }
      .theImg{
        border-radius: 5px;
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        z-index: 2;
        background-position: center;
        background-size: cover;
        z-index: 3;
      }
      &.loading{
        &:after{
          background-image: url(../assets/loading-2.svg);
          background-position: center;
          background-size: 40px auto;
          background-repeat: no-repeat;
        }
      }
      &.addImage{
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-weight: bold;
        color: #0245a7;
        .ai{
          position: relative;
          z-index: 3;
        }
        img{
          display: block;
          height: 24px;
          margin: 0 auto 5px;
        }
      }
      &:hover{
        &:before{
          background-color: #999;
          opacity: 1;
        }
      }
      &.active{
        &:before{
          background-color: #0e5bd2;
          opacity: 1;
        }
      }
    }
  }
  .addAudio{
    color: #0f5cd2;
    border: #0f5cd2 2px solid;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    font-weight: 700;
    .aa{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    img{
      height: 20px;
      float: left;
      margin-right: 8px;
    }
    img.white{
      display: none;
    }
    &:hover{
      color: #fff;
      background-color: #0f5cd2;
      img.white{
        display: inline-block;
      }
      img.blue{
        display: none;
      }
    }
  }
}


.formAction{
  position: fixed;
  bottom: 0;
  left: 300px;
  right: 0;
  background-color: #fff;
  // box-shadow: 0 0 6px rgba(0,0,0,.1);
  border-top: #ddd 1px solid;
  padding: 7px 0;
  text-align: right;
  z-index: 4;
  .formActionCnt{
    position: relative;
    max-width: 700px;
    margin: 0 auto;
    .btn{
      margin-left: 10px;
      float: right;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 40px auto;
      &.loading{
        background-image: url(../assets/loading-2.svg);
        background-color: #ccc;
        cursor: default;
        box-shadow: none !important;
        span{
          visibility: hidden;
        }
      }
      &.disabled{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none !important;
      }
    }
    .draftSaved{
      position: relative;
      float: right;
      height: 36px;
      width: 60px;
      span{
        color: #0057d8;
        font-size: 14px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .loadingImg{
        display: none;
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        svg{
          width: 100%;
          height: 100%;
        }
      }
    }
    .draftSaved.loading{
      span{
        display: none;
      }
      .loadingImg{
        display: block;
      }
    }
    .btnConfig{
      float: right;
      width: 36px;
      height: 36px;
      padding: 0;
      position: relative;
      .theBtn{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        border-radius: 50%;
        background-image: url(../assets/settings.png);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #fff;
        opacity: .5;
        cursor: pointer;
      }
      .theBtn:hover{
        background-color: #eee;
        opacity: 1;
      }
      .configOverlay{
        position: fixed;
        left: 0; right: 0; bottom: 0; top: 0;
        z-index: 8;
      }
      .configContent{
        position: absolute;
        bottom: 100%;
        width: 240px;
        padding: 20px;
        padding-bottom: 0;
        right: -95px;
        margin-bottom: 10px;
        box-shadow: 1px 1px 2px rgba(0,0,0,.1);
        background-color: #fff;
        text-align: left;
        border: #ccc 1px solid;
        z-index: 9;
        border-radius: 7px;
        .configItem{
          margin-bottom: 25px;
          h4{
            margin: 0;
            margin-bottom: 5px;
            font-size: 22px;
            font-weight: normal;
          }
          p{
            margin: 0;
            font-size: 13px;
          }
          .ciItem{
            font-size: 14px;
            margin-bottom: 12px;
            padding-bottom: 4px;
            border-bottom: #ccc 1px dotted;
            color: #767676;
            &.hasDd{
              padding-top: 4px;
              .dd{
                margin: -5px 0 2px;
                float: right;
                color: #444;
              }
            }
            span{
              float: right;
              color: #444;
            }
          }
        }
        .field{
          font-size: 15px;
          padding: 8px 10px;
          margin-top: 10px;
        }
      }
      .configContent:before{
        position: absolute;
        content: "";
        left: 50%;
        bottom: -10px;
        margin-left: 16px;
        border-top: #ccc 10px solid;
        border-left: transparent 10px solid;
        border-right: transparent 10px solid;
      }
      .configContent:after{
        position: absolute;
        content: "";
        left: 50%;
        bottom: -8px;
        margin-left: 17px;
        border-top: #fff 9px solid;
        border-left: transparent 9px solid;
        border-right: transparent 9px solid;
      }
    }
  }
}
</style>
